var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import { DosisBold } from "@irati/ui/src/global/fonts";
import { H3 } from "@irati/ui/src/Headings";
import { RECOGNITION } from "@irati/recognition/constants/feedTypes";
import { recognitionUsersToStringTitle, recognitionUsersToStringSubtitle } from "@irati/recognition/utils/recognitionUsersToString";
import CompanyValues from "@irati-web/companyvalues/src/components/CompanyValuesList";
import { Comments, CreateComment } from "../shared/Comments";
import WhoCreated from "../../WhoCreated";
import { CompanyValuesWrapper, Top, Bottom, EndDate as EndDateBase } from "../shared/layouts";
import UsersTooltip from "../../shared/UsersTooltip";
import WhoRewarded from "../../WhoRewarded";
import { Activity as IconsActivity } from "../../Icons";
import PrivateVisibilityMessage from "../../PrivateVisibilityMessage";
import ModeratedRecognitionMessage from "../shared/ModeratedRecognitionMessage";
import OccasionIcon from "../../shared/OccasionIcon";
var Bold = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), DosisBold);
var EndDate = styled(EndDateBase)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var ViewRecognition = /** @class */ (function (_super) {
    __extends(ViewRecognition, _super);
    function ViewRecognition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // @TODO we should be using the ref API but react-bootstrap does not support it
        _this.textarea = null;
        return _this;
    }
    ViewRecognition.prototype.render = function () {
        var _this = this;
        var _a = this.props, recognition = _a.recognition, onArchive = _a.onArchive, formatMessage = _a.formatMessage;
        var user = recognition.createdBy;
        if (!user) {
            user = authentication.user();
        }
        var users = recognition.receivers.results;
        var title = recognitionUsersToStringTitle(users, formatMessage);
        var subtitle = recognitionUsersToStringSubtitle(users, firstnameLastname(user), formatMessage);
        return (React.createElement(Fragment, null,
            React.createElement(Top, { className: "center" },
                React.createElement(H3, null,
                    React.createElement(UsersTooltip, { placement: "bottom", users: users },
                        React.createElement(Bold, null, title)),
                    React.createElement("br", null),
                    subtitle),
                React.createElement(CompanyValuesWrapper, null,
                    React.createElement(OccasionIcon, { occasion: recognition.occasion }),
                    React.createElement(CompanyValues, { companyValues: recognition.companyValues })),
                recognition.private && React.createElement(PrivateVisibilityMessage, { center: true }),
                React.createElement(EndDate, { endsAt: recognition.createdAt }),
                React.createElement(WhoRewarded, { reward: recognition.reward, rewardOrder: recognition.rewardOrder, user: recognition.createdBy }),
                React.createElement(ModeratedRecognitionMessage, { onArchive: onArchive, recognition: recognition }),
                React.createElement(WhoCreated, { createdBy: recognition.createdBy }),
                React.createElement(IconsActivity, { item: recognition, type: RECOGNITION, onClickComment: function () { if (_this.textarea)
                        _this.textarea.focus(); } })),
            React.createElement(Bottom, null,
                React.createElement(CreateComment, { item: recognition, type: RECOGNITION, key: recognition.comments.results.length, inputRef: function (t) { _this.textarea = t; } }),
                React.createElement(Comments, { item: recognition }))));
    };
    ViewRecognition.defaultProps = {
        id: "view-recognition"
    };
    return ViewRecognition;
}(Component));
export default injectIntl(ViewRecognition);
var templateObject_1, templateObject_2;
